import { render, staticRenderFns } from "./CharacterCard.vue?vue&type=template&id=20d96088&"
import script from "./CharacterCard.vue?vue&type=script&lang=js&"
export * from "./CharacterCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports